export default __webpack_public_path__ + "static/media/new-motion-icon.9b0460b7.png";